import i18n from "../i18n";
import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock, LogOut, Mail } from "lucide-react";

export default function PendingApprovalScreen() {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-screen grid place-items-center bg-background px-4" data-testid="pending-approval-screen">
            <Card className="max-w-md w-full p-8 text-center">
                <div className="w-16 h-16 rounded-full bg-amber-500/15 text-amber-600 grid place-items-center mx-auto">
                    <Clock className="w-8 h-8" />
                </div>
                <h1 className="text-2xl font-bold mt-5">{i18n.t("batch4.ecfdad01c3a0")}</h1>
                <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
                    {i18n.t("batch4.f8344ea1a802")} <b className="text-foreground">{user?.name || user?.email}</b>{i18n.t("batch4.6648b48c681f")}
                </p>
                <div className="mt-6 p-4 bg-muted/40 rounded-lg text-left space-y-2 text-xs">
                    <div className="flex items-center gap-2 text-muted-foreground">
                        <Mail className="w-3.5 h-3.5" />
                        <span>{i18n.t("batch4.d0e03a9704cf")} <b className="text-foreground">{user?.email}</b></span>
                    </div>
                    <div className="text-muted-foreground">
                        {i18n.t("batch4.62127687501d")} <b className="text-foreground">{i18n.t("batch4.9f1362cde54e")}</b>{i18n.t("batch4.e570a2dc1297")}
                    </div>
                </div>
                <Button
                    variant="outline"
                    onClick={logout}
                    className="mt-6 w-full h-11"
                    data-testid="pending-signout-btn"
                >
                    <LogOut className="w-4 h-4 mr-2" />{i18n.t("batch4.61fd08ff5c37")}
                </Button>
            </Card>
        </div>
    );
}
